module.exports =
  base: '/internal/dashboard'
  artwork:
    download: '/internal/dashboard/artwork/download'
    barcode:
      base: '/internal/dashboard/artwork/barcode/:barcode.png'
    mockup:
      demo:
        base: '/internal/dashboard/artwork/mockup/demo'
        blank: '/internal/dashboard/artwork/mockup/blank'
        generate: '/internal/dashboard/artwork/mockup/generate'
    moderation:
      base: '/internal/dashboard/artwork/moderation/'
      job: '/internal/dashboard/artwork/moderation/job/'
      context: '/internal/dashboard/artwork/moderation/:artworkId/context'
      similarity: '/internal/dashboard/artwork/moderation/:artworkId/similarity'
      waiting: '/internal/dashboard/artwork/moderation/waiting/'
    user:
      detail: '/internal/dashboard/artwork/user/:userId'
  order:
    base: '/internal/dashboard/order'
    stuck: '/internal/dashboard/order/stuck'
    flow: '/internal/dashboard/order/flow'
    count: '/internal/dashboard/order/count'
    breakdown: '/internal/dashboard/order/breakdown'
    reprint: '/internal/dashboard/order/:orderId/reprint'
    shipping:
      base: '/internal/dashboard/order/:orderId/shipping'
      prices: '/internal/dashboard/order/:orderId/shipping/prices'
      shippingWorkstation: '/internal/dashboard/order/:orderId/shipping/shippingWorkstation'
    issues:
      shipping:
        base: '/internal/dashboard/order/issues/shipping'
        errors: '/internal/dashboard/order/issues/shipping/errors'
      artwork:
        cancel: '/internal/dashboard/order/issues/artwork/cancel'
      inventory:
        base: '/internal/dashboard/order/issues/inventory'
    orderForm:
      orderPart: '/internal/dashboard/order/orderForm/:orderFormId/orderPart'
  design:
    base: '/internal/dashboard/design'
    conversion:
      base: '/internal/dashboard/design/artwork/conversion'
      queue: '/internal/dashboard/design/artwork/conversion/queue'
    qc:
      base: '/internal/dashboard/design/qc'
      job: '/internal/dashboard/design/qc/job'
      message: '/internal/dashboard/design/qc/:designId/message'
      approve: '/internal/dashboard/design/qc/:designId/approve'
      reject: '/internal/dashboard/design/qc/:designId/reject'
      waiting: '/internal/dashboard/design/qc/waiting'
    vectorization:
      base: '/internal/dashboard/design/vectorization'
      queue: '/internal/dashboard/design/vectorization/queue'
    mockup:
      demo:
        base: '/internal/dashboard/design/mockup/demo'
  user:
    base: '/internal/dashboard/user'
    review: '/internal/dashboard/user/review.csv'
    detail: '/internal/dashboard/user/:userId'
    assume: '/internal/dashboard/user/:userId/assume'
    pricing: '/internal/dashboard/user/:userId/pricing'
    credit: '/internal/dashboard/user/:userId/credit'
    addAsChild: '/internal/dashboard/user/:userId/addAsChild'
    resellerLicense: '/internal/dashboard/user/resellerLicense'
    referrer: '/internal/dashboard/user/referrer'
    delayReport:
      base: '/internal/dashboard/user/delayReport'
      addJob: '/internal/dashboard/user/delayReport/addJob'
  creditLineApplication:
    base: '/internal/dashboard/creditLineApplication'
    list: '/internal/dashboard/creditLineApplication/list'
    processedAfter: '/internal/dashboard/creditLineApplication/processedAfter'
    processedAfterCSV: '/internal/dashboard/creditLineApplication/processedAfter.csv'
    process: '/internal/dashboard/creditLineApplication/:creditLineApplicationId/process'
  employee:
    base: '/internal/dashboard/employee'
    performance: '/internal/dashboard/employee/performance'
    supervisor: '/internal/dashboard/employee/supervisor'
    timesheets: '/internal/dashboard/employee/timesheets'
    csvTimesheets: '/internal/dashboard/employee/csvTimesheets'
    shifts: '/internal/dashboard/employee/shifts'
    present: '/internal/dashboard/employee/present'
    salesReport: '/internal/dashboard/employee/salesReport'
  facility:
    shipments: '/internal/dashboard/facility/shipments'
    inventory:
      flow: '/internal/dashboard/facility/inventory/flow'
    updater: '/internal/dashboard/facility/updater'
    projects:
      data: '/internal/dashboard/facility/projects/data'
  claim:
    base: '/internal/dashboard/claim'
    count: '/internal/dashboard/claim/count'
    detail: '/internal/dashboard/claim/:claimId'
    resolve: '/internal/dashboard/claim/:claimId/resolve'
    reprint: '/internal/dashboard/claim/:claimId/reprint'
  workstation:
    printerTest:
      base: '/internal/workstation/printerTest'
    loginToken:
      base: '/internal/workstation/token'
    pick:
      screenprint:
        sticker: '/internal/workstation/pick/screenprint/sticker'
      status: '/internal/workstation/pick/barcode/:barcode/:facility/status'
      barcode: '/internal/workstation/pick/barcode/:barcode/:facility'
      sticker: '/internal/workstation/pick/sticker'
    stickering:
      replacements: '/internal/workstation/stickering/replacements'
      replacementsStatus: '/internal/workstation/stickering/replacementsStatus'
      stickers: '/internal/workstation/stickering/stickers'
    employee:
      base: '/internal/workstation/employee'
      base2: '/internal/workstation/employee2'
    embr:
      detail: '/internal/workstation/embr/:embrId/detail'
      artwork: '/internal/workstation/embr/:embrId/artwork'
      printEmbr: '/internal/workstation/embr/:embrId/printEmbr'
      jobSheet: '/internal/workstation/embr/:referenceId/jobSheet'
      qc:
        base: '/internal/workstation/embr/qc'
        escalate: '/internal/workstation/embr/qc/escalate'
    manual:
      base: '/internal/workstation/manual'
    inventory:
      rack:
        storeInstruction: '/internal/workstation/inventory/rack/:rackId/storeInstruction'
        marshalStatus: '/internal/workstation/inventory/rack/:rackId/marshalStatus'
        marshalInstruction: '/internal/workstation/inventory/rack/:rackId/bin/:bin/marshalInstruction'
        storeMarshalInstruction: '/internal/workstation/inventory/rack/storeMarshalInstruction/:facility'
        floatStatus: '/internal/workstation/inventory/rack/floatStatus/:facility'
        fitStatus: '/internal/workstation/inventory/rack/:rackId/fitStatus'
        pull: '/internal/workstation/inventory/rack/pull'
        shortPull: '/internal/workstation/inventory/rack/shortPull'
        update: '/internal/workstation/inventory/rack/update'
        update2: '/internal/workstation/inventory/rack/update2'
        remove: '/internal/workstation/inventory/rack/remove'
        pullStatus: '/internal/workstation/inventory/rack/pullStatus'
        storedStatus: '/internal/workstation/inventory/rack/storedStatus'
        countStatus: '/internal/workstation/inventory/rack/countStatus'
        countSheet: '/internal/workstation/inventory/rack/countSheet'
        cycleCount:
          base: '/internal/workstation/inventory/rack/cycleCount'
          base2: '/internal/workstation/inventory/rack/cycleCount2'
      orderPart:
        pickAt: '/internal/workstation/inventory/orderPart/:orderPartId/pickAt'
        location: '/internal/workstation/inventory/orderPart/:orderPartId/location'
        orderStatus: '/internal/workstation/inventory/orderPart/order/:ooOrderId/orderStatus'
        swap: '/internal/workstation/inventory/orderPart/:orderPartId/swap'
        swapStatus: '/internal/workstation/inventory/orderPart/swapStatus'
      orderPartRejection:
        approve: '/internal/workstation/inventory/orderPartRejection/approve'
      barcode:
        cart: '/internal/workstation/inventory/barcode/cart'
        employee: '/internal/workstation/inventory/barcode/employee'
      box:
        store: '/internal/workstation/inventory/box/:boxId/store'
        pullList: '/internal/workstation/inventory/box/:facility/pullList'
        pull: '/internal/workstation/inventory/box/:boxId/pull'
      blankOrder:
        base: '/internal/workstation/inventory/blankOrder'
        barcode: '/internal/workstation/inventory/blankOrder/barcode/:barcode'
        generate: '/internal/workstation/inventory/blankOrder/:facility/generate'
        query: '/internal/workstation/inventory/blankOrder/:facility/query'
        exception: '/internal/workstation/inventory/blankOrder/:blankOrderId/exception'
        history: '/internal/workstation/inventory/blankOrder/:blankOrderId/history'
        packingSlip: '/internal/workstation/inventory/blankOrder/:blankOrderId/packingSlip'
        cancel: '/internal/workstation/inventory/blankOrder/:blankOrderId/cancel'
        shortage: '/internal/workstation/inventory/blankOrder/:blankOrderId/shortage'
        package:
          base: '/internal/workstation/inventory/blankOrder/package'
          barcode: '/internal/workstation/inventory/blankOrder/package/barcode/:barcode'
          manual: '/internal/workstation/inventory/blankOrder/package/manual'
          receive: '/internal/workstation/inventory/blankOrder/:blankOrderId/package/:packageId/receive'
          reprintStickers: '/internal/inventory/blankOrder/:blankOrderId/package/:packageId/reprintStickers'
          extraSticker: '/internal/inventory/blankOrder/extraSticker'
          stickerData: '/internal/workstation/inventory/blankOrder/:blankOrderId/package/:packageId/stickerData'
          tracking: '/internal/workstation/inventory/blankOrder/package/tracking/:barcode'
          tracking2: '/internal/workstation/inventory/blankOrder/package/tracking2/:context/:facility'
      blankOrderItem:
        findByProductItem: '/internal/workstation/inventory/blankOrderItem/:productItemId/findByProductItem'
        cancel: '/internal/workstation/inventory/blankOrderItem/:blankOrderItemId/cancel'
      shortage:
        base: '/internal/workstation/inventory/shortage'
      orders:
        base: '/internal/workstation/inventory/orders'
      dock:
        base: '/internal/workstation/inventory/dock'
        prime: '/internal/workstation/inventory/primeDock'
      dock2:
        ups: '/internal/workstation/inventory/dock2/ups'
        truckline: '/internal/workstation/inventory/dock2/truckline'
        primeInventory: '/internal/workstation/inventory/dock2/primeInventory'
        primePick: '/internal/workstation/inventory/dock2/primePick'
      swap:
        base: '/internal/workstation/inventory/swap'
      receiving:
        base: '/internal/workstation/inventory/receiving'
        base2: '/internal/workstation/inventory/receiving2'
      extraInventory:
        base: '/internal/workstation/inventory/extraInventory'
      extraStickers:
        base: '/internal/workstation/inventory/extraStickers'
      storing:
        screenprint: '/internal/workstation/inventory/storing/screenprint' # TODO: Remove
        preprint: '/internal/workstation/inventory/storing/preprint'
      sort:
        screenprint: '/internal/workstation/inventory/sort/screenprint' # TODO: Remove
        preprint: '/internal/workstation/inventory/sort/preprint'
        exception: '/internal/workstation/inventory/sort/exception'
      pull:
        dtg: '/internal/workstation/inventory/pullDtg'
        dtg2: '/internal/workstation/inventory/pullDtg2'
        screenprint: '/internal/workstation/inventory/pullScreenprint'
        screenprint2: '/internal/workstation/inventory/pullScreenprint2'
        embr: '/internal/workstation/inventory/pullEmbr'
        embr2: '/internal/workstation/inventory/pullEmbr2'
        status: '/internal/workstation/inventory/pull/status'
      pick:
        base: '/internal/workstation/inventory/pick'
      missing:
        list: '/internal/workstation/inventory/missing'
      csv:
        prime: '/internal/workstation/inventory/primeCSV'
    shipping:
      base: '/internal/workstation/shipping'
      base2: '/internal/workstation/shipping2'
      bulk: '/internal/workstation/shipping/bulk'
      scan: '/internal/workstation/shipping/scan'
      barcode: '/internal/workstation/shipping/barcode/:barcode'
      label: '/internal/workstation/shipping/:formId/label'
      print: '/internal/workstation/shipping/print'
      printShippingForm: '/internal/workstation/shipping/shippingForm/:shippingFormId/print'
      ship: '/internal/workstation/shipping/shippingForm/:shippingFormId/ship'
      splitShip: '/internal/workstation/shipping/shippingForm/:shippingFormId/splitShip'
      shipList:
        base: '/internal/workstation/shipping/shipList'
      short:
        activate: '/internal/workstation/shipping/shippingForm/:shippingFormId/shortActivate'
        init: '/internal/workstation/shipping/shippingForm/:shippingFormId/shortInit'
        confirm: '/internal/workstation/shipping/shippingForm/:shippingFormId/shortConfirm'
      shippingForm:
        base: '/internal/workstation/shippingForm'
        tracking: '/internal/workstation/shippingForm/tracking'
        shippingCode: '/internal/workstation/shippingForm/:shippingFormId/shippingCode'
        shippingBilling: '/internal/workstation/shippingForm/:shippingFormId/shippingBilling'
        void: '/internal/workstation/shippingForm/:shippingFormId/void'
        unship: '/internal/workstation/shippingForm/:shippingFormId/unship'
        cancel: '/internal/workstation/shippingForm/:shippingFormId/cancel'
        barcode: '/internal/workstation/shippingForm/:shippingFormId/barcode'
        bulkCancelOrUpdateSLA: '/internal/workstation/shippingForm/:shippingFormId/bulkCancelOrUpdateSLA' # deprecated
        bulkUpdateSLA: '/internal/workstation/shippingForm/:shippingFormId/bulkUpdateSLA'
        instructions: '/internal/workstation/shippingForm/:shippingFormId/instructions'
      force: '/internal/workstation/shipping/force'
    report:
      base: '/internal/workstation/report'
    reship:
      base: '/internal/workstation/reship'
      check: '/internal/workstation/reship/check'
      create: '/internal/workstation/reship/create'
      checkBin: '/internal/workstation/reship/checkBin'
      barcode:
        return: '/internal/workstation/reship/barcode/:barcode/return'
        check: '/internal/workstation/reship/barcode/:barcode/check'
      expired: '/internal/workstation/reship/:reshipId/expired'
      confirm: '/internal/workstation/reship/:reshipId/confirm'
    dtg:
      base3: '/internal/workstation/dtg3'
      print: '/internal/workstation/dtg/print'
      notify: '/internal/workstation/dtg/notify'
      rips: '/internal/workstation/dtg/barcode/:barcode/rips'
      barcode: '/internal/workstation/dtg/barcode/:barcode'
      pretreat:
        productItem: '/internal/workstation/dtg/pretreat/productItem/:productItemId'
      rip2:
        barcode: '/internal/workstation/dtg/rip2/barcode/:barcode'
        artwork: '/internal/workstation/dtg/rip2/:ripId/artwork'
        detail: '/internal/workstation/dtg/rip2/:ripId/detail'
        history: '/internal/workstation/dtg/rip2/:ripId/history'
        hardReset: '/internal/workstation/dtg/rip2/:ripId/hardReset'
      rip:
        download: '/internal/workstation/dtg/rip/:printId/download'
        rerip: '/internal/workstation/dtg/rip/:printId/rerip'
        debug: '/internal/workstation/dtg/rip/:printId/debug'
        artwork: '/internal/workstation/dtg/rip/:printId/artwork'
        enqueue: '/internal/workstation/dtg/rip/enqueue'
      ripProfile:
        detail: '/internal/dashbord2/workstation/dtg/ripProfile/:ripProfileId'
        search: '/internal/dashbord2/workstation/dtg/ripProfile/-/search'
        bulkById: '/internal/dashbord2/workstation/dtg/ripProfile/bulkById'
      cart: '/internal/workstation/dtg/cart'
      pallet: '/internal/workstation/dtg/pallet'
      qc:
        base: '/internal/workstation/dtg/qc'
        base3: '/internal/workstation/dtg/qc3'
        report: '/internal/workstation/dtg/qc/report'
        escalate: '/internal/workstation/dtg/qc/escalate'
        countRejects: '/internal/workstation/dtg/qc/countRejects'
        escalateReason: '/internal/workstation/dtg/qc/escalateReason'
      artwork2: '/internal/workstation/dtg/artwork2'
    pretreat:
      base4: '/internal/workstation/pretreat4'
      viper: '/internal/workstation/pretreat/viper'
      synergy: '/internal/workstation/pretreat/synergy'
    custom:
      base: '/internal/workstation/custom'
      barcode: '/internal/workstation/custom/barcode/:barcode'
      complete: '/internal/workstation/custom/:formId/complete'
      printPart: '/internal/workstation/custom/printPart'
    qc:
      base: '/internal/workstation/qc'
      accept: '/internal/workstation/qc/:orderPartId/accept'
      reject: '/internal/workstation/qc/:orderPartId/reject'
      photo: '/internal/workstation/qc/:orderPartId/'
      spot: '/internal/workstation/qc/spot'
    rack2:
      store: '/internal/workstation/rack/:rackId/bin/:bin/store'
      transfer: '/internal/workstation/rack/:rackId/bin/:bin/transfer'
      remove: '/internal/workstation/rack/:rackId/bin/:bin/remove'
      storeInstruction: '/internal/workstation/rack2/:rackId/storeInstruction'
      marshalStatus: '/internal/workstation/rack2/:rackId/marshalStatus'
      shippingStatus: '/internal/workstation/rack2/:rackId/shippingStatus'
      marshalDirectInstruction: '/internal/workstation/rack2/marshalDirectInstruction'
      marshalInstruction: '/internal/workstation/rack2/:rackId/bin/:bin/marshalInstruction'
      retrieveInstruction: '/internal/workstation/rack2/:rackId/retrieveInstruction'
      product:
        storeInstruction: '/internal/workstation/rack/product/storeInstruction'
        store: '/internal/workstation/rack/:rackId/bin/:bin/product/store'
        update: '/internal/workstation/rack/:rackId/bin/:bin/product/update'
        uploadCSV: '/internal/workstation/rack/product/uploadCSV/:facility'
        parseCSV: '/internal/workstation/rack/product/parseCSV/:facility'
        assign: '/internal/workstation/rack/product/assign'
        remove: '/internal/workstation/rack2/:rackId/bin/:bin/product/remove'
      overflowSort:
        storeInstruction: '/internal/workstation/rack/overflowSort/rack/:rackId/storeInstruction'
        stage2Instruction: '/internal/workstation/rack/overflowSort/rack/:rackId/stage2Instruction'
        empty: '/internal/workstation/rack/overflowSort/rack/:rackId/empty'
        shippingStatus: '/internal/workstation/rack/overflowSort/rack/:rackId/shippingStatus'
    rack:
      header:
        sticker: '/internal/workstation/rack/:rackId/header/sticker'
      bin:
        base: '/internal/workstation/rack/bin'
        sticker: '/internal/workstation/rack/:rackId/bin/sticker'
      create: '/internal/workstation/rack/create'
      delete: '/internal/workstation/rack/delete'
      empty: '/internal/workstation/rack/empty'
      shipping: '/internal/workstation/rack/shipping'
      shippingAutobag: '/internal/workstation/rack/shippingAutobag'
      shippingSplit: '/internal/workstation/rack/shippingSplit'
      store:
        exception: '/internal/workstation/rack/store/exception'
        rackSortKickout: '/internal/workstation/rack/store/rackSortKickout'
      reconcilePick: '/internal/workstation/rack/reconcilePick'
      reconcile: '/internal/workstation/rack/reconcile'
      marshal: '/internal/workstation/rack/marshal'
      rejection:
        approve: '/internal/workstation/rack/rejection/approve'
      missing:
        list: '/internal/workstation/rack/missing'
        reports: '/internal/workstation/rack/missing/reports'
      barcode: '/internal/workstation/rack/barcode/:barcode'
      orderPart:
        base: '/internal/workstation/rack/orderPart'
        location: '/internal/workstation/rack/orderPart/:orderPartId'
        status: '/internal/workstation/rack/orderPart/:orderPartId/status'
        overflowStatus: '/internal/workstation/rack/orderPart/:orderPartId/overflowStatus'
        history: '/internal/workstation/rack/orderPart/:orderPartId/history'
        kickoutResolve: '/internal/workstation/rack/orderPart/:orderPartId/kickoutResolve'
        resticker:
          query: '/internal/workstation/rack/orderPart/resticker/query'
          orderData: '/internal/workstation/rack/orderPart/resticker/orderData'
          garments: '/internal/workstation/rack/orderPart/resticker/garments'
      shipList: '/internal/workstation/rack/shipList'
    product:
      base: '/internal/workstation/product'
      edit: '/internal/workstation/product/edit'
    productItem:
      base: '/internal/workstation/productItem'
      tag:
        base: '/internal/workstation/productItem/tag'
        edit: '/internal/workstation/productItem/tag/edit'
      pretreat:
        base: '/internal/workstation/productItem/pretreat'
        edit: '/internal/workstation/productItem/pretreat/edit'
      embr:
        base: '/internal/workstation/productItem/embr'
        edit: '/internal/workstation/productItem/embr/edit'
      sizing:
        edit: '/internal/workstation/productItem/sizing/edit'
  ping:
    base: '/internal/dashboard/ping'
  tablet:
    base: '/internal/dashboard/tablet'
  orderLog:
    track: '/internal/orderLog/track'
  audit:
    barcodes: '/internal/audit/barcodes'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/dashboard.coffee